import { useMemo } from 'react';
import { defineBlock, useEditor, useInspectorControl, smartProps, BlockWrapper } from '@smartfire/js-block-engine';
import filterReactProps from 'filter-react-props';
import DownloadIcon from '../assets/icons/download';
import Inspector from './inspector';
import clsx from 'clsx';
import style from './style.module.scss';

export const ButtonBlock = ({ showInspector = true, ...props }) => {
    useInspectorControl(showInspector ? Inspector : () => '');

    return (
        <BlockWrapper.Div
            className={clsx(
                'smartfire-block-button',
                style.wrapper,
                props.align && style[props.align],
                props.externalBorder && style.externalBorder,
            )}
        >
            <Button {...props} />
        </BlockWrapper.Div>
    );
};

export const Button = ({
    text,
    linkType,
    link,
    targetBlank = false,
    type = 'filled',
    externalBorder = false,
    color = '',
    className = null,
    disabled = false,
    tagName = 'a',
    isSubmit = false,
    postType = null,
    postId = 0,
    taxonomy = '',
    termId = 0,
    fileId = 0,
    ...props
}) => {
    const { isEditing } = useEditor();

    const href = useMemo(() => {
        switch (linkType) {
            case 'email':
                return 'mailto:' + link;

            case 'tel':
                return 'tel:' + link;

            default:
                return link;
        }
    }, [link, linkType]);

    const Tag = tagName;

    const buttonProps = useMemo(() => {
        let buttonProps = {
            ...props,
            className: clsx(className, style.button, style[linkType], style[type], disabled && style.disabled),
            style: { '--color': color },
            disabled,
        };

        if (!isEditing && href) buttonProps.href = href;
        if (targetBlank) buttonProps.target = '_blank';
        if (linkType === 'file') buttonProps.download = true;
        if (isSubmit) buttonProps.type = 'submit';

        return buttonProps;
    }, [props, className, disabled, type, isEditing, href, targetBlank, linkType, isSubmit, color]);

    return (
        <Tag {...filterReactProps(buttonProps)}>
            {linkType === 'file' && <DownloadIcon />}
            {text && <span className={style.text}>{text}</span>}
            {props.children}
        </Tag>
    );
};

export default defineBlock({
    Block: ButtonBlock,
    smartProps: {
        text: smartProps.string.withDefault(''),
        linkType: smartProps.string.withDefault('page'),
        link: smartProps.string.withDefault(''),
        postType: smartProps.string.withDefault(''),
        postId: smartProps.number.withDefault(0),
        taxonomy: smartProps.string.withDefault(''),
        termId: smartProps.number.withDefault(0),
        fileId: smartProps.number.withDefault(0),
        targetBlank: smartProps.bool.withDefault(false),
        type: smartProps.string.withDefault('filled'),
        externalBorder: smartProps.bool.withDefault(false),
        color: smartProps.string.withDefault(style.orange),
        align: smartProps.string.withDefault('center'),
    },
    setup: {
        title: 'Bouton',
    },
});
